const findObject = (key, value, array) => {
	let i = array.length - 1
	while (i>=0) {
		if (array[i][key] === value) {
			return array[i]
		}
		i -= 1
	}
	return ''
}

export default findObject
